var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useRef, useState } from 'react';
export var usePaginationQuery = function (_a) {
    var queryFn = _a.queryFn, _b = _a.initialPage, initialPage = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 10 : _c, _d = _a.enabled, enabled = _d === void 0 ? true : _d;
    var _e = useState([]), data = _e[0], setData = _e[1];
    var _f = useState(initialPage), page = _f[0], setPage = _f[1];
    var _g = useState(false), isLoading = _g[0], setIsLoading = _g[1];
    var _h = useState(false), isLoadingMore = _h[0], setIsLoadingMore = _h[1];
    var _j = useState(0), total = _j[0], setTotal = _j[1];
    var _k = useState(true), hasMore = _k[0], setHasMore = _k[1];
    var _l = useState(null), error = _l[0], setError = _l[1];
    // Tracking fetch state to prevent multiple simultaneous fetches
    var mountedRef = useRef(true);
    var fetchPage = useCallback(function (currentPage_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([currentPage_1], args_1, true), void 0, function (currentPage, isInitial) {
            var result_1, totalPages, err_1, fetchError;
            if (isInitial === void 0) { isInitial = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Prevent multiple simultaneous fetches and ensure component is mounted
                        if (!mountedRef.current)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        // Manage loading states
                        setIsLoading(isInitial);
                        setIsLoadingMore(!isInitial);
                        setError(null);
                        return [4 /*yield*/, queryFn(currentPage, limit)];
                    case 2:
                        result_1 = _a.sent();
                        if (!mountedRef.current)
                            return [2 /*return*/];
                        setTotal(result_1.total);
                        // Append or replace data based on initial load
                        setData(function (prevData) { return (isInitial ? result_1.data : __spreadArray(__spreadArray([], prevData, true), result_1.data, true)); });
                        totalPages = Math.ceil(result_1.total / limit);
                        setHasMore(currentPage < totalPages);
                        setPage(currentPage);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        if (!mountedRef.current)
                            return [2 /*return*/];
                        fetchError = err_1 instanceof Error ? err_1 : new Error('An unknown error occurred');
                        setError(fetchError);
                        setHasMore(false);
                        return [3 /*break*/, 5];
                    case 4:
                        // Reset fetching flag
                        if (mountedRef.current) {
                            setIsLoading(false);
                            setIsLoadingMore(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [queryFn, limit]);
    var fetchNextPage = useCallback(function () {
        if (!hasMore || isLoadingMore)
            return;
        var nextPage = page + 1;
        fetchPage(nextPage);
    }, [page, hasMore, isLoadingMore, fetchPage]);
    var refetch = useCallback(function () {
        setHasMore(true);
        setError(null);
        fetchPage(initialPage, true);
    }, [initialPage, fetchPage]);
    // Initial fetch and cleanup
    useEffect(function () {
        mountedRef.current = true;
        if (enabled) {
            fetchPage(initialPage, true);
        }
        return function () {
            mountedRef.current = false;
        };
    }, [enabled, fetchPage, initialPage]);
    return {
        data: data,
        isLoading: isLoading,
        isLoadingMore: isLoadingMore,
        page: page,
        total: total,
        hasMore: hasMore,
        error: error,
        fetchNextPage: fetchNextPage,
        refetch: refetch,
        setData: setData,
    };
};
